export var DefaultStages;
(function (DefaultStages) {
    DefaultStages["loading"] = "loading";
    DefaultStages["results"] = "results";
    DefaultStages["noResults"] = "no results";
})(DefaultStages || (DefaultStages = {}));
